// extracted by mini-css-extract-plugin
module.exports = {"full":"LoadingView_full__3GN3v"};